/* eslint-disable react-hooks/exhaustive-deps */
import { ToastManager } from "@osttra/ds-react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Applications from "./components/app-gallery/Applications";
import ErrorPage from "./components/error/ErrorPage";
import OtpLogin from "./components/otp-login/OtpLogin";
import SamlLogin from "./components/saml-login/SamlLogin";

function App() {
  return (
    <div className="App">
      <ToastManager>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to={`/saml/login${window.location.search}`} replace />} />
            <Route path="/login" element={<Navigate to={`/saml/login${window.location.search}`} replace />} />
            <Route path="/otp-login" element={<OtpLogin />} />
            <Route path="/saml/login" element={<SamlLogin />} />
            <Route path="/applications" element={<Applications />} />
            <Route path="/error" element={<ErrorPage errorCode={500} />} />
            <Route path="*" element={<ErrorPage errorCode={404} />} />
          </Routes>
        </BrowserRouter>
      </ToastManager>
    </div>
  );
}

export default App;
